import { render } from "./BorrowDialog.vue?vue&type=template&id=79d79776&scoped=true&ts=true"
import script from "./BorrowDialog.vue?vue&type=script&lang=ts"
export * from "./BorrowDialog.vue?vue&type=script&lang=ts"

import "./BorrowDialog.vue?vue&type=style&index=0&id=79d79776&scoped=true&lang=scss"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-79d79776"]])

export default __exports__
import QInput from 'quasar/src/components/input/QInput.js';
import QSlider from 'quasar/src/components/slider/QSlider.js';
import QBtn from 'quasar/src/components/btn/QBtn.js';
import QField from 'quasar/src/components/field/QField.js';
import qInstall from "../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QInput,QSlider,QBtn,QField});
